export default function HomePage() {
  return (
    <div className="flex flex-col items-center justify-center bg-linear-to-br from-gray-50 to-gray-100 py-16">
      <div className="rounded-lg bg-white px-8 py-10 text-center shadow-lg sm:mx-auto sm:max-w-xl">
        <h1 className="font-bold text-3xl text-gray-800">Reader Tracker</h1>
        <p className="mt-4 text-gray-600">Welcome to Reader Tracker.</p>
        <div className="mt-8 flex justify-center">
          <a
            href="/admin"
            className="rounded-lg bg-gray-800 px-6 py-2 font-medium text-white transition-colors hover:bg-gray-700"
          >
            Go to Admin
          </a>
        </div>
      </div>
    </div>
  )
}
